import { Table, TableBody, TableContainer } from "@mui/material";

import LoadingIndicator from "../fields/LoadingIndicator";
import NothingToShow from "../fields/NothingToShow";

import NetworkSettingsHistoryTableHeader from "./NetworkSettingsHistoryTableHeader";
import NetworkSettingsHistoryTableRow from "./NetworkSettingsHistoryTableRow";

export default function NetworkSettingsHistoryTable({ data = [], loading = false }) {
  if (loading) {
    return (
      <div className="min-h-[220px]">
        <LoadingIndicator />
      </div>
    );
  }

  if (!data.length) {
    return (
      <div className="flex min-h-[220px] items-center justify-center px-4 py-6">
        <NothingToShow />
      </div>
    );
  }

  return (
    <TableContainer>
      <Table
        sx={{
          tableLayout: "fixed",
          "& .MuiTableCell-root": {
            paddingLeft: 0,
            paddingRight: 2,
          },
          "& .MuiTableRow-root:last-child .MuiTableCell-root": {
            borderBottom: "none",
          },
        }}
      >
        <NetworkSettingsHistoryTableHeader />
        <TableBody>
          {data.map((row) => (
            <NetworkSettingsHistoryTableRow
              key={row?.id ?? row?.pk ?? JSON.stringify(row)}
              row={row}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
